/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-console */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable prefer-destructuring */
import React, { useState, useEffect, useCallback } from 'react';

import PropTypes from 'prop-types';

import {
  MdHelp,
  MdArrowDropDown,
  MdRemove,
  MdAdd,
  MdDone,
  MdEdit,
  MdLockOpen,
} from 'react-icons/md';

import { FaExclamation, FaExclamationTriangle } from 'react-icons/fa';

import Swal from 'sweetalert2';

import { toast } from 'react-toastify';

import { Spin, Switch, Modal, Tooltip, DatePicker } from 'antd';

import { ClipLoader } from 'react-spinners';

import { IoMdArrowBack } from 'react-icons/io';

import moment from 'moment';

import 'moment/locale/pt-br';

import locale from 'antd/es/date-picker/locale/pt_BR';

import history from '~/services/history';

import api from '~/services/api';

import { store } from '~/store';

import { useSelector, useDispatch } from 'react-redux';

import * as actionsCareLines from '~/store/modules/careLines/actions';

import iconGreen from '../../assets/icons/icon-warning-green.png';

import iconError from '~/assets/icons/icon-error.svg';
import GreenButton from '~/components/Button/index';

import Breadcumbs from '~/components/Breadcumbs';

import ModalPedidoReaberturaComp from '~/components/ModalPedidoReaberturaComp';

import { optionsModalCancel, modalConfirm } from './optionsModal';

import {
  PageTitle,
  BoxContent,
  BoxContentHeader,
  BoxList,
  SwitchButton,
  ButtonList,
  MonthStatus,
  ButtonStatus,
  BoxButtonSave,
  NoContent,
} from '~/pages/Indicadores/style';
import IndicadorList from './components/IndicadorList';

moment.locale('pt-br');

const { MonthPicker } = DatePicker;

const IndicadoresInstituicao = () => {
  const { token, roles } = useSelector(state => state.auth);

  const dispath = useDispatch();

  const [careLinesInst, setCareLinesInst] = useState([]);

  const [idInstituicao, setIdInstituicao] = useState(null);

  const [competencias, setCompetencias] = useState([]);

  const [modalIsVisible, setModalIsVisible] = useState(false);

  const [modalConfirma, setModalConfirma] = useState(false);

  const [modalLoading, setModalLoading] = useState(false);
  useState(false);

  const [loading, setLoading] = useState(true);

  const [reabrirCompetenciaMes, setReabrirCompetenciaMes] = useState(null);

  // CHECKED

  const [indicPainelGeralAtivo, setIndicPainelGeralAtivo] = useState(null);
  const [indicAvcAtivo, setIndicAvcAtivo] = useState(null);
  const [artroDeQuadrilAtivo, setArtroDeQuadrilAtivo] = useState(null);
  const [cancerDeMamaAtivo, setCancerDeMamaAtivo] = useState(null);
  const [cancerDeProstataAtivo, setCancerDeProstataAtivo] = useState(null);
  const [sepseChoqueSepticoAtivo, setSepseChoqueSepticoAtivo] = useState(null);
  const [sindromeCaAtivo, setSindromeCaAtivo] = useState(null);

  // PERIODO DE INDICADORES

  const [monthsCompVisible, setMonthsCompVisible] = useState(false);
  const [periodoInicialGeral, setPeriodoInicialGeral] = useState(null);
  const [periodoFinalGeral, setPeriodoFinalGeral] = useState(null);
  const [periodoGeralEdit, setPeriodoGeralEdit] = useState(true);

  const [monthsCompVisibleAVC, setMonthsCompVisibleAVC] = useState(false);
  const [periodoInicialAVC, setPeriodoInicialAVC] = useState(null);
  const [periodoFinalAVC, setPeriodoFinalAVC] = useState(null);
  const [periodoAVCEdit, setPeriodoAVCEdit] = useState(true);

  const [monthsCompVisibleAQ, setMonthsCompVisibleAQ] = useState(false);
  const [periodoInicialAQ, setPeriodoInicialAQ] = useState(null);
  const [periodoFinalAQ, setPeriodoFinalAQ] = useState(null);
  const [periodoAQEdit, setPeriodoAQEdit] = useState(true);

  const [monthsCompVisibleCM, setMonthsCompVisibleCM] = useState(false);
  const [periodoInicialCM, setPeriodoInicialCM] = useState(null);
  const [periodoFinalCM, setPeriodoFinalCM] = useState(null);
  const [periodoCMEdit, setPeriodoCMEdit] = useState(true);

  const [monthsCompVisibleCP, setMonthsCompVisibleCP] = useState(false);
  const [periodoInicialCP, setPeriodoInicialCP] = useState(null);
  const [periodoFinalCP, setPeriodoFinalCP] = useState(null);
  const [periodoCPEdit, setPeriodoCPEdit] = useState(true);

  const [monthsCompVisibleSCS, setMonthsCompVisibleSCS] = useState(false);
  const [periodoInicialSCS, setPeriodoInicialSCS] = useState(null);
  const [periodoFinalSCS, setPeriodoFinalSCS] = useState(null);
  const [periodoSCSEdit, setPeriodoSCSEdit] = useState(true);

  const [monthsCompVisibleSCA, setMonthsCompVisibleSCA] = useState(false);
  const [periodoInicialSCA, setPeriodoInicialSCA] = useState(null);
  const [periodoFinalSCA, setPeriodoFinalSCA] = useState(null);
  const [periodoSCAEdit, setPeriodoSCAEdit] = useState(true);

  const [showErrors, setShowErrors] = useState([]);

  const idInst = sessionStorage.getItem('institutionId');
  useEffect(() => {
    const getInstituicao = async () => {
      let response;
      try {
        response = await api.get(`/instituicoes/${idInst}/dados-instituicao`, {
          headers: {
            Authorization: String(token),
          },
        });
        setLoading(false);

        setIdInstituicao(response.data.id);

        const { indicadores } = response?.data;

        setCareLinesInst(indicadores);
        console.log(indicadores);
        indicadores.forEach(indicador => {
          const indicadorName = indicador.nomeIdentificador;

          const setActive =
            (indicadorName === 'indicadores_painel_geral' &&
              (setIndicPainelGeralAtivo(indicador.ativo),
              setPeriodoInicialGeral(indicador.periodoInicial),
              setPeriodoFinalGeral(indicador.periodoFinal))) ||
            (indicadorName === 'acidente_vascular_cerebral' &&
              (setIndicAvcAtivo(indicador.ativo),
              setPeriodoInicialAVC(indicador.periodoInicial),
              setPeriodoFinalAVC(indicador.periodoFinal))) ||
            (indicadorName === 'artropatia_de_quadril' &&
              (setArtroDeQuadrilAtivo(indicador.ativo),
              setPeriodoInicialAQ(indicador.periodoInicial),
              setPeriodoFinalAQ(indicador.periodoFinal))) ||
            (indicadorName === 'cancer_de_mama' &&
              (setCancerDeMamaAtivo(indicador.ativo),
              setPeriodoInicialCM(indicador.periodoInicial),
              setPeriodoFinalCM(indicador.periodoFinal))) ||
            (indicadorName === 'cancer_de_prostata' &&
              (setCancerDeProstataAtivo(indicador.ativo),
              setPeriodoInicialCP(indicador.periodoInicial),
              setPeriodoFinalCP(indicador.periodoFinal))) ||
            (indicadorName === 'sepse_e_choque_septico' &&
              (setSepseChoqueSepticoAtivo(indicador.ativo),
              setPeriodoInicialSCS(indicador.periodoInicial),
              setPeriodoFinalSCS(indicador.periodoFinal))) ||
            (indicadorName === 'sindrome_coronariana_aguda' &&
              (setSindromeCaAtivo(indicador.ativo),
              setPeriodoInicialSCA(indicador.periodoInicial),
              setPeriodoFinalSCA(indicador.periodoFinal)));
        });
      } catch (error) {
        console.log('error', error);
      }

      setLoading(false);
    };

    const getCompetencia = async () => {
      try {
        await api
          .get(`indicadores-gerais/instituicoes/${idInst}/competencias`, {
            headers: {
              Authorization: String(token),
            },
          })
          .then(response => {
            setCompetencias(response.data.reverse());
          });
      } catch (error) {
        console.log('error :', error);
      }
    };

    getInstituicao();
    getCompetencia();
  }, []);

  const reabrirCompetencia = mes => {
    setReabrirCompetenciaMes(mes);

    setModalIsVisible(true);
  };

  const enviaPedidoReabertura = async () => {
    setModalIsVisible(false);
    setModalConfirma(false);
    setModalLoading(true);

    try {
      const data = {
        mesReabertura: String(reabrirCompetenciaMes),
      };

      const response = await api.post(
        `indicadores-gerais/instituicoes/${idInst}/solicita-reabertura-competencia`,
        data,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: String(token),
          },
        }
      );
      setModalLoading(false);

      if (response.status >= 200 && response.status <= 201) {
        Swal.fire({
          html: `<div class="modalPedidoAnalise">
                  <div class="modalPedidoAnaliseHeader">
                  <img src="${iconGreen}">
                  <h2>Pedido <span>enviado para análise.</span> </h2></div>
                  <div class="modalPedidoAnaliseBody">
                  <p>O pedido de reabertura foi enviado para análise da equipe administradora do sistema.</p>
                  </div>
                </div>`,
          showConfirmButton: true,
          confirmButtonText: 'OK! Entendi.',
          confirmButtonColor: '#74a50a',
        }).then(res => {
          window.location.reload();
        });
      }
    } catch (error) {
      setModalLoading(false);

      Swal.fire({
        html: `<div class="modalReaberturaError">
                <img src="${iconError}">
                <p>${error.response.data.fields[0].exception}.</p>
              </div>`,
        showConfirmButton: true,
        confirmButtonText: 'Ok, obrigado.',
        confirmButtonColor: '#cc0000',
      });
    }
  };

  const openIndicator = useCallback(error => {
    switch (error) {
      case 'periodoInicialGeral':
        setMonthsCompVisible(true);
        break;

      case 'periodoInicialAVC':
        setMonthsCompVisibleAVC(true);
        break;

      case 'periodoInicialAQ':
        setMonthsCompVisibleAQ(true);
        break;

      case 'periodoInicialCM':
        setMonthsCompVisibleCM(true);
        break;

      case 'periodoInicialCP':
        setMonthsCompVisibleCP(true);
        break;

      case 'periodoInicialSCS':
        setMonthsCompVisibleSCS(true);
        break;

      case 'periodoInicialSCA':
        setMonthsCompVisibleSCA(true);
        break;

      default:
        break;
    }
  }, []);

  useEffect(() => {
    if (showErrors.length > 0) {
      showErrors.forEach(error => {
        openIndicator(error);
      });
    }
  }, [showErrors]);

  const salvaAlteracoes = async () => {
    // Verifica errors

    const itemsDates = [
      {
        name: 'periodoInicialGeral',
        indicador: periodoInicialGeral,
        ativo: indicPainelGeralAtivo,
      },
      {
        name: 'periodoInicialAVC',
        indicador: periodoInicialAVC,
        ativo: indicAvcAtivo,
      },
      {
        name: 'periodoInicialAQ',
        indicador: periodoInicialAQ,
        ativo: artroDeQuadrilAtivo,
      },
      {
        name: 'periodoInicialCM',
        indicador: periodoInicialCM,
        ativo: cancerDeMamaAtivo,
      },

      {
        name: 'periodoInicialCP',
        indicador: periodoInicialCP,
        ativo: cancerDeProstataAtivo,
      },

      {
        name: 'periodoInicialSCS',
        indicador: periodoInicialSCS,
        ativo: sepseChoqueSepticoAtivo,
      },

      {
        name: 'periodoInicialSCA',
        indicador: periodoInicialSCA,
        ativo: sindromeCaAtivo,
      },
    ];

    const itemsDatesErr = [];
    itemsDates.forEach(item => {
      if (!item.indicador && item.ativo) {
        itemsDatesErr.push(item.name);
      }
    });

    setShowErrors([...showErrors, ...itemsDatesErr]);

    if (itemsDatesErr.length > 0) {
      Swal.fire({
        title: `Atenção`,
        text: `Favor inserir as datas de início de coleta.`,
        icon: 'error',
        confirmButtonColor: '#74a50a',
      });

      return;
    }

    // Verifica errors

    setLoading(true);
    const data = [
      {
        ativo: Boolean(indicPainelGeralAtivo),
        nomeIdentificador: 'indicadores_painel_geral',
        periodoInicial: periodoInicialGeral,
        periodoFinal: periodoFinalGeral,
      },
      {
        ativo: Boolean(indicAvcAtivo),
        nomeIdentificador: 'acidente_vascular_cerebral',
        periodoInicial: periodoInicialAVC,
        periodoFinal: periodoFinalAVC,
      },
      {
        ativo: Boolean(artroDeQuadrilAtivo),
        nomeIdentificador: 'artropatia_de_quadril',
        periodoInicial: periodoInicialAQ,
        periodoFinal: periodoFinalAQ,
      },
      {
        ativo: Boolean(cancerDeMamaAtivo),
        nomeIdentificador: 'cancer_de_mama',
        periodoInicial: periodoInicialCM,
        periodoFinal: periodoFinalCM,
      },
      {
        ativo: Boolean(cancerDeProstataAtivo),
        nomeIdentificador: 'cancer_de_prostata',
        periodoInicial: periodoInicialCP,
        periodoFinal: periodoFinalCP,
      },
      {
        ativo: Boolean(sepseChoqueSepticoAtivo),
        nomeIdentificador: 'sepse_e_choque_septico',
        periodoInicial: periodoInicialSCS,
        periodoFinal: periodoFinalSCS,
      },
      {
        ativo: Boolean(sindromeCaAtivo),
        nomeIdentificador: 'sindrome_coronariana_aguda',
        periodoInicial: periodoInicialSCA,
        periodoFinal: periodoFinalSCA,
      },
    ];

    try {
      const response = await api.post(
        `/instituicoes/${idInst}/indicadores-linha-de-cuidado`,
        data,
        {
          headers: {
            Authorization: String(token),
          },
        }
      );

      setLoading(false);

      if (
        String(response?.status).substr(0, 2) === '20' ||
        response.status === 201
      ) {
        dispath(actionsCareLines.listarLcsRequest({ institutionId: idInst }));

        toast.success(response.data.menssagem, {
          autoClose: 5000,
        });
        setInterval(() => {
          window.location.reload();
        }, 2000);
      }
    } catch (error) {
      setLoading(false);

      let errorRes = error?.response?.data?.error;

      if (errorRes === 'Forbidden') {
        errorRes = 'Operação não autorizada';
      }

      Swal.fire({
        title: 'Atenção',
        html: `${errorRes ||
          'Não foi possível concluir a operação'}. <br > ${errorRes &&
          ' Verifique e tente novamente.'}`,
        icon: 'warning',
        confirmButtonColor: '#74a50a',
      });
    }
  };

  const onChangeAVC = checked => {
    if (!checked) {
      Swal.fire(optionsModalCancel).then(result => {
        if (result.value) {
          setIndicAvcAtivo(checked);
          setMonthsCompVisibleAVC(false);
        }
      });
    } else {
      Swal.fire(modalConfirm).then(result => {
        if (result.value) {
          setIndicAvcAtivo(checked);
          setMonthsCompVisibleAVC(true);
        }
      });
    }
  };

  const onChangeADQ = checked => {
    if (!checked) {
      Swal.fire(optionsModalCancel).then(result => {
        if (result.value) {
          setArtroDeQuadrilAtivo(checked);
          setMonthsCompVisibleAQ(false);
        }
      });
    } else {
      Swal.fire(modalConfirm).then(result => {
        if (result.value) {
          setArtroDeQuadrilAtivo(checked);
          setMonthsCompVisibleAQ(true);
        }
      });
    }
  };

  const onChangeCancerDeMama = checked => {
    if (!checked) {
      Swal.fire(optionsModalCancel).then(result => {
        if (result.value) {
          setCancerDeMamaAtivo(checked);
          setMonthsCompVisibleCM(false);
        }
      });
    } else {
      Swal.fire(modalConfirm).then(result => {
        if (result.value) {
          setCancerDeMamaAtivo(checked);
          setMonthsCompVisibleCM(true);
        }
      });
    }
  };

  const onChangeCancerDeProstata = checked => {
    if (!checked) {
      Swal.fire(optionsModalCancel).then(result => {
        if (result.value) {
          setCancerDeProstataAtivo(checked);
          setMonthsCompVisibleCP(false);
        }
      });
    } else {
      Swal.fire(modalConfirm).then(result => {
        if (result.value) {
          setCancerDeProstataAtivo(checked);
          setMonthsCompVisibleCP(true);
        }
      });
    }
  };

  const onChangeSindromeCa = checked => {
    if (!checked) {
      Swal.fire(optionsModalCancel).then(result => {
        if (result.value) {
          setSindromeCaAtivo(checked);
          setMonthsCompVisibleSCA(false);
        }
      });
    } else {
      Swal.fire(modalConfirm).then(result => {
        if (result.value) {
          setSindromeCaAtivo(checked);
          setMonthsCompVisibleSCA(true);
        }
      });
    }
  };

  const normalizeDate = useCallback(periodo => {
    let periodoIn;
    if (!periodo) {
      periodoIn = '';
    } else {
      const splitDate = periodo.split('/');
      periodoIn = moment(`${splitDate[1]}-${splitDate[0]}`, 'YYYY-MM');
    }

    return periodoIn;
  }, []);

  if (loading) {
    return (
      <BoxContent>
        <div className="boxSpin">
          <ClipLoader size={50} color="#74a50a" loading={loading} />
        </div>
      </BoxContent>
    );
  }

  return (
    <>
      <ModalPedidoReaberturaComp
        modalIsVisible={modalIsVisible}
        setModalIsVisible={setModalIsVisible}
        enviaPedidoReabertura={enviaPedidoReabertura}
      />

      <Modal
        visible={modalLoading}
        centered
        footer={null}
        closable={null}
        width="120px"
      >
        <Spin tip="Enviando..." />
      </Modal>
      <Breadcumbs path="indicadores" pathTitle="Indicadores" />
      <PageTitle>
        <div className="voltar">
          <button type="button" onClick={() => history.goBack()}>
            <IoMdArrowBack size={15} /> Voltar
          </button>
        </div>
        <div className="headerInline">
          <span>Indicadores </span>
        </div>
      </PageTitle>

      <BoxContent>
        {careLinesInst.length > 0 ? (
          <BoxContentHeader>
            <div className="indicadoresHeader">
              <span>
                Indicadores
                {/* <MdArrowDropDown size={20} /> */}
              </span>
            </div>
            <div className="coletaHeader">
              <span>
                <Tooltip title="Primeira competência na qual o indicador ou a linha de cuidado foi informada pela instituição.">
                  Início da coleta <MdHelp size={15} />
                </Tooltip>
              </span>
            </div>
            <div className="coletaHeader">
              <span>
                <Tooltip title="Data final de coleta do indicador ou da linha de cuidado.">
                  Fim da coleta <MdHelp size={15} />
                </Tooltip>
              </span>
            </div>
            <div className="statusHeader">
              <Tooltip title="Indicadores ou linhas de cuidado com status “Ativo” terão competências abertas para envio de dados. Status “Inativo” significa que a instituição não coleta dados para cálculo do indicador ou linha de cuidado em questão.">
                Status <MdHelp size={15} />
              </Tooltip>
            </div>
          </BoxContentHeader>
        ) : (
          <BoxContent>
            <div className="boxSpin">
              <ClipLoader size={50} color="#74a50a" loading={loading} />
            </div>
          </BoxContent>
        )}
        {careLinesInst.length > 0 &&
          careLinesInst.map(indicador => {
            const {
              periodoInicial,
              periodoFinal,
              nomeIdentificador,
            } = indicador;

            if (nomeIdentificador === 'indicadores_painel_geral') {
              return (
                <BoxList key={nomeIdentificador}>
                  <div className="BoxListItems">
                    <div className="indicador">
                      <button
                        type="button"
                        onClick={() => setMonthsCompVisible(!monthsCompVisible)}
                      >
                        {monthsCompVisible ? (
                          <ButtonList monthsCompVisible={monthsCompVisible}>
                            <MdRemove size={20} />
                          </ButtonList>
                        ) : (
                          <ButtonList monthsCompVisible={monthsCompVisible}>
                            <MdAdd size={20} />
                          </ButtonList>
                        )}
                      </button>
                      <span
                        style={{
                          color: !indicPainelGeralAtivo && '#b4b4b4',
                        }}
                      >
                        {nomeIdentificador === 'indicadores_painel_geral' &&
                          'Painel Geral – competências'}
                      </span>
                    </div>
                    <div className="coleta">
                      <p>{periodoInicial}</p>
                    </div>
                    <div className="coleta">
                      <p>{periodoFinal}</p>
                    </div>
                    <div className="status"></div>
                  </div>
                  {monthsCompVisible && (
                    <>
                      <div className="BoxListCompetences">
                        <div className="verticalLine" />

                        <div className="monthsComp">
                          <div className="monthsCompHeader">
                            <div className="monthsCompHeader_child">
                              <div>
                                <span>Meses de competência</span>
                              </div>
                              <div className="status_competencia">
                                <span>Status de competência</span>
                              </div>
                            </div>

                            <div className="monthsCompHeader_child">
                              <Tooltip title="Pedidos de reabertura de competência reabilitam o envio de dados submetidos anteriormente.">
                                <span>
                                  Reabertura de competência <MdHelp size={15} />
                                </span>
                              </Tooltip>
                            </div>
                          </div>

                          {competencias.length > 0 &&
                            competencias.map(solicitacao => {
                              const {
                                status,
                                mesCompetencia,
                                idSolicitacao,
                                dataHoraSolicitacao,
                              } = solicitacao;

                              const statusTxt =
                                (status === 'C' && 'Finalizado') ||
                                (status === 'CN' &&
                                  'Finalizada e nao enviado') ||
                                (status === 'O' && 'Em aberto') ||
                                (status === 'A' &&
                                  'Pedido de reabertura enviado');

                              return (
                                <div className="monthsCompList">
                                  <div className="monthItem">
                                    <span>{mesCompetencia}</span>
                                  </div>
                                  <MonthStatus status={status}>
                                    <ButtonStatus status={status}>
                                      {(status === 'C' && (
                                        <MdDone size={15} />
                                      )) ||
                                        (status === 'CN' && (
                                          <MdDone size={15} />
                                        )) ||
                                        (status === 'O' && (
                                          <FaExclamationTriangle size={15} />
                                        )) ||
                                        (status === 'A' && (
                                          <FaExclamation size={10} />
                                        ))}
                                    </ButtonStatus>
                                    <span>{statusTxt}</span>
                                  </MonthStatus>
                                  <div className="monthMessage" />
                                  <div className="monthButton">
                                    <button
                                      onClick={() =>
                                        reabrirCompetencia(mesCompetencia)
                                      }
                                      type="button"
                                      disabled={
                                        status === 'O' ||
                                        (status === 'A' && true)
                                      }
                                    >
                                      Reabrir competência
                                    </button>
                                  </div>
                                </div>
                              );
                            })}
                        </div>

                        <div className="dataColetaFooter">
                          <div>
                            <span>Data de início de coleta:</span>

                            <MonthPicker
                              className={
                                showErrors.includes('periodoInicialGeral') &&
                                'errorMonthPickerInput'
                              }
                              name="periodoInicialGeral"
                              id="periodoInicialGeral"
                              format="MM/YYYY"
                              locale={locale}
                              placeholder="Mês / Ano"
                              value={normalizeDate(periodoInicialGeral)}
                              onChange={(value, dateString) => {
                                setShowErrors(
                                  showErrors.filter(
                                    item => item !== 'periodoInicialGeral'
                                  )
                                );

                                setPeriodoInicialGeral(dateString);
                              }}
                            />
                          </div>

                          <div>
                            <button
                              className="edit"
                              type="button"
                              onClick={() =>
                                setPeriodoGeralEdit(!periodoGeralEdit)
                              }
                            >
                              {periodoGeralEdit ? (
                                <>
                                  <MdEdit size={20} />
                                  Editar
                                </>
                              ) : (
                                <>
                                  <MdLockOpen size={20} />
                                  Editar
                                </>
                              )}
                            </button>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </BoxList>
              );
            }
          })}

        <IndicadorList />

        {careLinesInst.length > 0 &&
          careLinesInst.map(indicador => {
            const {
              periodoInicial,
              periodoFinal,
              nomeIdentificador,
            } = indicador;

            if (nomeIdentificador !== 'indicadores_painel_geral') {
              return (
                <BoxList key={nomeIdentificador}>
                  {(nomeIdentificador === 'acidente_vascular_cerebral' && (
                    <>
                      <div className="BoxListItems">
                        <div className="indicador">
                          {indicAvcAtivo && (
                            <button
                              type="button"
                              onClick={() =>
                                setMonthsCompVisibleAVC(!monthsCompVisibleAVC)
                              }
                            >
                              {monthsCompVisibleAVC ? (
                                <ButtonList
                                  monthsCompVisibleAVC={monthsCompVisibleAVC}
                                >
                                  <MdRemove size={20} />
                                </ButtonList>
                              ) : (
                                <ButtonList
                                  monthsCompVisibleAVC={monthsCompVisibleAVC}
                                >
                                  <MdAdd size={20} />
                                </ButtonList>
                              )}
                            </button>
                          )}

                          <span
                            style={{
                              color: !indicAvcAtivo && '#b4b4b4',
                            }}
                          >
                            Acidente Vascular Cerebral - AVC
                          </span>
                        </div>
                        <div className="coleta">
                          <p>{periodoInicial}</p>
                        </div>
                        <div className="coleta">
                          <p>{periodoFinal}</p>
                        </div>
                        <div className="status">
                          <SwitchButton>
                            <Switch
                              checked={indicAvcAtivo}
                              onChange={onChangeAVC}
                            />
                            <span
                              style={{
                                color: !indicAvcAtivo && '#b4b4b4',
                              }}
                            >
                              {indicAvcAtivo ? 'Ativo' : 'Inativo'}
                            </span>
                          </SwitchButton>
                        </div>
                      </div>

                      <div>
                        {monthsCompVisibleAVC && (
                          <div className="BoxListCompetences">
                            <div className="dataColetaFooter dataColetaFooterOff">
                              <div>
                                <span>Data de início de coleta:</span>

                                <MonthPicker
                                  className={
                                    showErrors.includes('periodoInicialAVC') &&
                                    'errorMonthPickerInput'
                                  }
                                  name="periodoInicialAVC"
                                  id="periodoInicialAVC"
                                  format="MM/YYYY"
                                  locale={locale}
                                  placeholder="Mês / Ano"
                                  value={normalizeDate(periodoInicialAVC)}
                                  onChange={(value, dateString) => {
                                    setShowErrors(
                                      showErrors.filter(
                                        item => item !== 'periodoInicialAVC'
                                      )
                                    );
                                    setPeriodoInicialAVC(dateString);
                                  }}
                                />
                              </div>

                              <div>
                                <button
                                  className="edit"
                                  type="button"
                                  onClick={() =>
                                    setPeriodoAVCEdit(!periodoAVCEdit)
                                  }
                                >
                                  {periodoAVCEdit ? (
                                    <>
                                      <MdEdit size={20} />
                                      Editar
                                    </>
                                  ) : (
                                    <>
                                      <MdLockOpen size={20} />
                                      Editar
                                    </>
                                  )}
                                </button>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </>
                  )) ||
                    (nomeIdentificador === 'artropatia_de_quadril' && (
                      <>
                        <div className="BoxListItems">
                          <div className="indicador">
                            {artroDeQuadrilAtivo && (
                              <button
                                type="button"
                                onClick={() =>
                                  setMonthsCompVisibleAQ(!monthsCompVisibleAQ)
                                }
                              >
                                {monthsCompVisibleAQ ? (
                                  <ButtonList
                                    monthsCompVisibleAQ={monthsCompVisibleAQ}
                                  >
                                    <MdRemove size={20} />
                                  </ButtonList>
                                ) : (
                                  <ButtonList
                                    monthsCompVisibleAQ={monthsCompVisibleAQ}
                                  >
                                    <MdAdd size={20} />
                                  </ButtonList>
                                )}
                              </button>
                            )}

                            <span
                              style={{
                                color: !artroDeQuadrilAtivo && '#b4b4b4',
                              }}
                            >
                              Artropatia de Quadril
                            </span>
                          </div>
                          <div className="coleta">
                            <p>{periodoInicial}</p>
                          </div>
                          <div className="coleta">
                            <p>{periodoFinal}</p>
                          </div>
                          <div className="status">
                            <SwitchButton>
                              <Switch
                                checked={artroDeQuadrilAtivo}
                                onChange={onChangeADQ}
                              />
                              <span
                                style={{
                                  color: !artroDeQuadrilAtivo && '#b4b4b4',
                                }}
                              >
                                {artroDeQuadrilAtivo ? 'Ativo' : 'Inativo'}
                              </span>
                            </SwitchButton>
                          </div>
                        </div>

                        <div>
                          {monthsCompVisibleAQ && (
                            <div className="BoxListCompetences">
                              <div className="dataColetaFooter dataColetaFooterOff">
                                <div>
                                  <span>Data de início de coleta:</span>

                                  <MonthPicker
                                    className={
                                      showErrors.includes('periodoInicialAQ') &&
                                      'errorMonthPickerInput'
                                    }
                                    name="periodoInicialAQ"
                                    id="periodoInicialAQ"
                                    format="MM/YYYY"
                                    locale={locale}
                                    placeholder="Mês / Ano"
                                    value={normalizeDate(periodoInicialAQ)}
                                    onChange={(value, dateString) => {
                                      setShowErrors(
                                        showErrors.filter(
                                          item => item !== 'periodoInicialAQ'
                                        )
                                      );
                                      setPeriodoInicialAQ(dateString);
                                    }}
                                  />
                                </div>

                                <div>
                                  <button
                                    className="edit"
                                    type="button"
                                    onClick={() =>
                                      setPeriodoAQEdit(!periodoAQEdit)
                                    }
                                  >
                                    {periodoAQEdit ? (
                                      <>
                                        <MdEdit size={20} />
                                        Editar
                                      </>
                                    ) : (
                                      <>
                                        <MdLockOpen size={20} />
                                        Editar
                                      </>
                                    )}
                                  </button>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </>
                    )) ||
                    (nomeIdentificador === 'cancer_de_mama' && (
                      <>
                        <div className="BoxListItems">
                          <div className="indicador">
                            {cancerDeMamaAtivo && (
                              <button
                                type="button"
                                onClick={() =>
                                  setMonthsCompVisibleCM(!monthsCompVisibleCM)
                                }
                              >
                                {monthsCompVisibleCM ? (
                                  <ButtonList
                                    monthsCompVisibleCM={monthsCompVisibleCM}
                                  >
                                    <MdRemove size={20} />
                                  </ButtonList>
                                ) : (
                                  <ButtonList
                                    monthsCompVisibleCM={monthsCompVisibleCM}
                                  >
                                    <MdAdd size={20} />
                                  </ButtonList>
                                )}
                              </button>
                            )}

                            <span
                              style={{
                                color: !cancerDeMamaAtivo && '#b4b4b4',
                              }}
                            >
                              Câncer de Mama
                            </span>
                          </div>
                          <div className="coleta">
                            <p>{periodoInicial}</p>
                          </div>
                          <div className="coleta">
                            <p>{periodoFinal}</p>
                          </div>
                          <div className="status">
                            <SwitchButton>
                              <Switch
                                checked={cancerDeMamaAtivo}
                                onChange={onChangeCancerDeMama}
                              />
                              <span
                                style={{
                                  color: !cancerDeMamaAtivo && '#b4b4b4',
                                }}
                              >
                                {cancerDeMamaAtivo ? 'Ativo' : 'Inativo'}
                              </span>
                            </SwitchButton>
                          </div>
                        </div>

                        <div>
                          {monthsCompVisibleCM && (
                            <div className="BoxListCompetences">
                              <div className="dataColetaFooter dataColetaFooterOff">
                                <div>
                                  <span>Data de início de coleta:</span>

                                  <MonthPicker
                                    className={
                                      showErrors.includes('periodoInicialCM') &&
                                      'errorMonthPickerInput'
                                    }
                                    name="periodoInicialCM"
                                    id="periodoInicialCM"
                                    format="MM/YYYY"
                                    locale={locale}
                                    placeholder="Mês / Ano"
                                    value={normalizeDate(periodoInicialCM)}
                                    onChange={(value, dateString) => {
                                      setShowErrors(
                                        showErrors.filter(
                                          item => item !== 'periodoInicialCM'
                                        )
                                      );
                                      setPeriodoInicialCM(dateString);
                                    }}
                                  />
                                </div>

                                <div>
                                  <button
                                    className="edit"
                                    type="button"
                                    onClick={() =>
                                      setPeriodoCMEdit(!periodoCMEdit)
                                    }
                                  >
                                    {periodoCMEdit ? (
                                      <>
                                        <MdEdit size={20} />
                                        Editar
                                      </>
                                    ) : (
                                      <>
                                        <MdLockOpen size={20} />
                                        Editar
                                      </>
                                    )}
                                  </button>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </>
                    )) ||
                    (nomeIdentificador === 'cancer_de_prostata' && (
                      <>
                        <div className="BoxListItems">
                          <div className="indicador">
                            {cancerDeProstataAtivo && (
                              <button
                                type="button"
                                onClick={() =>
                                  setMonthsCompVisibleCP(!monthsCompVisibleCP)
                                }
                              >
                                {monthsCompVisibleCP ? (
                                  <ButtonList
                                    monthsCompVisibleCP={monthsCompVisibleCP}
                                  >
                                    <MdRemove size={20} />
                                  </ButtonList>
                                ) : (
                                  <ButtonList
                                    monthsCompVisibleCP={monthsCompVisibleCP}
                                  >
                                    <MdAdd size={20} />
                                  </ButtonList>
                                )}
                              </button>
                            )}

                            <span
                              style={{
                                color: !cancerDeProstataAtivo && '#b4b4b4',
                              }}
                            >
                              Câncer de Próstata
                            </span>
                          </div>
                          <div className="coleta">
                            <p>{periodoInicial}</p>
                          </div>
                          <div className="coleta">
                            <p>{periodoFinal}</p>
                          </div>
                          <div className="status">
                            <SwitchButton>
                              <Switch
                                checked={cancerDeProstataAtivo}
                                onChange={onChangeCancerDeProstata}
                              />
                              <span
                                style={{
                                  color: !cancerDeProstataAtivo && '#b4b4b4',
                                }}
                              >
                                {cancerDeProstataAtivo ? 'Ativo' : 'Inativo'}
                              </span>
                            </SwitchButton>
                          </div>
                        </div>

                        <div>
                          {monthsCompVisibleCP && (
                            <div className="BoxListCompetences">
                              <div className="dataColetaFooter dataColetaFooterOff">
                                <div>
                                  <span>Data de início de coleta:</span>

                                  <MonthPicker
                                    className={
                                      showErrors.includes('periodoInicialCP') &&
                                      'errorMonthPickerInput'
                                    }
                                    name="periodoInicialCP"
                                    id="periodoInicialCP"
                                    format="MM/YYYY"
                                    locale={locale}
                                    placeholder="Mês / Ano"
                                    value={normalizeDate(periodoInicialCP)}
                                    onChange={(value, dateString) => {
                                      setShowErrors(
                                        showErrors.filter(
                                          item => item !== 'periodoInicialCP'
                                        )
                                      );
                                      setPeriodoInicialCP(dateString);
                                    }}
                                  />
                                </div>

                                <div>
                                  <button
                                    className="edit"
                                    type="button"
                                    onClick={() =>
                                      setPeriodoCPEdit(!periodoCPEdit)
                                    }
                                  >
                                    {periodoCPEdit ? (
                                      <>
                                        <MdEdit size={20} />
                                        Editar
                                      </>
                                    ) : (
                                      <>
                                        <MdLockOpen size={20} />
                                        Editar
                                      </>
                                    )}
                                  </button>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </>
                    )) ||
                    (nomeIdentificador === 'sepse_e_choque_septico' && (
                      <>
                        <div className="BoxListItems">
                          <div className="indicador">
                            {sepseChoqueSepticoAtivo && (
                              <button
                                type="button"
                                onClick={() =>
                                  setMonthsCompVisibleSCS(!monthsCompVisibleSCS)
                                }
                              >
                                {monthsCompVisibleSCS ? (
                                  <ButtonList
                                    monthsCompVisibleSCS={monthsCompVisibleSCS}
                                  >
                                    <MdRemove size={20} />
                                  </ButtonList>
                                ) : (
                                  <ButtonList
                                    monthsCompVisibleSCS={monthsCompVisibleSCS}
                                  >
                                    <MdAdd size={20} />
                                  </ButtonList>
                                )}
                              </button>
                            )}

                            <span
                              style={{
                                color: !sepseChoqueSepticoAtivo && '#b4b4b4',
                              }}
                            >
                              Sepse e Choque Séptico
                            </span>
                          </div>
                          <div className="coleta">
                            <p>{periodoInicial}</p>
                          </div>
                          <div className="coleta">
                            <p>{periodoFinal}</p>
                          </div>
                          <div className="status" />
                        </div>

                        <div>
                          {monthsCompVisibleSCS && (
                            <div className="BoxListCompetences">
                              <div className="dataColetaFooter dataColetaFooterOff">
                                <div>
                                  <span>Data de início de coleta:</span>

                                  <MonthPicker
                                    className={
                                      showErrors.includes(
                                        'periodoInicialSCS'
                                      ) && 'errorMonthPickerInput'
                                    }
                                    name="periodoInicialSCS"
                                    id="periodoInicialSCS"
                                    format="MM/YYYY"
                                    locale={locale}
                                    placeholder="Mês / Ano"
                                    value={normalizeDate(periodoInicialSCS)}
                                    onChange={(value, dateString) => {
                                      setShowErrors(
                                        showErrors.filter(
                                          item => item !== 'periodoInicialSCS'
                                        )
                                      );

                                      setPeriodoInicialSCS(dateString);
                                    }}
                                  />
                                </div>

                                <div>
                                  <button
                                    className="edit"
                                    type="button"
                                    onClick={() =>
                                      setPeriodoSCSEdit(!periodoSCSEdit)
                                    }
                                  >
                                    {periodoSCSEdit ? (
                                      <>
                                        <MdEdit size={20} />
                                        Editar
                                      </>
                                    ) : (
                                      <>
                                        <MdLockOpen size={20} />
                                        Editar
                                      </>
                                    )}
                                  </button>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </>
                    )) ||
                    (nomeIdentificador === 'sindrome_coronariana_aguda' && (
                      <>
                        <div className="BoxListItems">
                          <div className="indicador">
                            {sindromeCaAtivo && (
                              <button
                                type="button"
                                onClick={() =>
                                  setMonthsCompVisibleSCA(!monthsCompVisibleSCA)
                                }
                              >
                                {monthsCompVisibleSCA ? (
                                  <ButtonList
                                    monthsCompVisibleSCA={monthsCompVisibleSCA}
                                  >
                                    <MdRemove size={20} />
                                  </ButtonList>
                                ) : (
                                  <ButtonList
                                    monthsCompVisibleSCA={monthsCompVisibleSCA}
                                  >
                                    <MdAdd size={20} />
                                  </ButtonList>
                                )}
                              </button>
                            )}

                            <span
                              style={{
                                color: !sindromeCaAtivo && '#b4b4b4',
                              }}
                            >
                              Síndrome Coronariana Aguda - SCA
                            </span>
                          </div>
                          <div className="coleta">
                            <p>{periodoInicial}</p>
                          </div>
                          <div className="coleta">
                            <p> {periodoFinal} </p>
                          </div>
                          <div className="status">
                            <SwitchButton>
                              <Switch
                                checked={sindromeCaAtivo}
                                onChange={onChangeSindromeCa}
                              />
                              <span
                                style={{
                                  color: !sindromeCaAtivo && '#b4b4b4',
                                }}
                              >
                                {sindromeCaAtivo ? 'Ativo' : 'Inativo'}
                              </span>
                            </SwitchButton>
                          </div>
                        </div>

                        <div>
                          {monthsCompVisibleSCA && (
                            <div className="BoxListCompetences">
                              <div className="dataColetaFooter dataColetaFooterOff">
                                <div>
                                  <span>Data de início de coleta:</span>

                                  <MonthPicker
                                    className={
                                      showErrors.includes(
                                        'periodoInicialSCA'
                                      ) && 'errorMonthPickerInput'
                                    }
                                    name="periodoInicialSCA"
                                    id="periodoInicialSCA"
                                    format="MM/YYYY"
                                    locale={locale}
                                    placeholder="Mês / Ano"
                                    value={normalizeDate(periodoInicialSCA)}
                                    onChange={(value, dateString) => {
                                      setShowErrors(
                                        showErrors.filter(
                                          item => item !== 'periodoInicialSCA'
                                        )
                                      );

                                      setPeriodoInicialSCA(dateString);
                                    }}
                                  />
                                </div>

                                <div>
                                  <button
                                    className="edit"
                                    type="button"
                                    onClick={() =>
                                      setPeriodoSCAEdit(!periodoSCAEdit)
                                    }
                                  >
                                    {periodoSCAEdit ? (
                                      <>
                                        <MdEdit size={20} />
                                        Editar
                                      </>
                                    ) : (
                                      <>
                                        <MdLockOpen size={20} />
                                        Editar
                                      </>
                                    )}
                                  </button>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </>
                    ))}
                </BoxList>
              );
            }
          })}

        {careLinesInst.length > 0 && (
          <BoxButtonSave>
            <button
              onClick={() => salvaAlteracoes()}
              style={{ padding: '0 60px' }}
              type="button"
            >
              Salvar alterações
            </button>
          </BoxButtonSave>
        )}
      </BoxContent>
    </>
  );
};

IndicadoresInstituicao.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.shape({
      id: PropTypes.number.isRequired,
    }),
  }).isRequired,
};

export default IndicadoresInstituicao;
